export default __webpack_public_path__ + "static/media/Mask Group 146.9da47630.svg";